<template>
    <div class="content_wrapper">
        <p>
            <ul style="list-style: none;">
                <li v-for="pdf in pdfs" :key="pdf.id">
                    <a :href="pdf.link">{{pdf.filename}}</a>
                </li>
            </ul>
        </p>
      </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
let id = 0;
export default {
    // Declare the properties this instance will expect to be passed in.
    props: {
        // Represents the selected district.
        dist: String,
        // Represents the selected year.
        year: Number,
    },

    // Declare data this instance will use.
    data(){
        return{
            // Build a base URL to the download.php script
            baseURL: `${this.$baseAPI}common/rates_renewals/download.php?filename=`,
            // Contain the objects used to contain file info that is used for retrieval.
            pdfs: []
        }
    },

    methods: {
        async fillPDFs(){
            // Make an API call to get the list of available pdf files.
            const payload = {method: 'get_available_pdfs', district: this.dist, year: this.year};
            // Await the result of the API call.
            const api_result = await axios.post(`${this.$baseAPI}common/rates_renewals/index.php`, JSON.stringify(payload), {
                headers: {'Content-Type' : 'application/json'}
            });

            // Destructure the API result.
            let result = api_result.data.result;

            // Build an object containing the filename and a prebuilt URL.
            for(let i = 0; i < result.length; i++){
                let pdf = {
                    id: id,
                    filename: result[i],
                    link: `${this.baseURL}${result[i]}`
                }
                id++;
                // Push the object to the array on this instance.
                this.pdfs.push(pdf);
            }
            return;
        }
    },

    // Runs upon entering the mounted lifecycle hook.
    mounted(){
        // Reset the id counter for listable pdfs.
        id = 0;
        // Fill the pdf array.
        this.fillPDFs();
    },

    // Declare watcher for the year attribute.
    watch: {
        year(){
            // Empty the pdfs array.
            this.pdfs = [];
            // Reset the id counter for listable pdfs.
            id = 0;
            // Fill the pdf array.
            this.fillPDFs();
        }
    }
}
</script>

<style>
.content_wrapper{
  border: 1px solid black;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  width: 50vw;
  margin-left: 25%;
  margin-top: 10px;
  padding-left: 10px;
  padding-top: 10px;
}
</style>